var exports = {
  "XG": "Scroller.module__scroller___TzNicX",
  "xG": "Scroller.module__scrollerTextarea___TzNicX",
};

module.exports = exports;
